import React from 'react'
import I18nCRUD from '../components/I18nCRUD'
import {I18nType} from '../../../utils/types'
import {i18n}  from '../../../i18n'
import {PageHeader} from 'antd'

const GenderPage = () => {
    return (
        <div>
            <PageHeader className='site-page-header-responsive' title={i18n.t('planner.gender.title')}
                        onBack={() => window.history.back()}>
                <I18nCRUD
                    type={I18nType.GENDER}
                    newTitle={i18n.t('planner.gender.new')}
                    failUpdate={i18n.t('planner.gender.failUpdate')}
                    failGet={i18n.t('planner.gender.failGet')}
                    deleteTitle={i18n.t('planner.gender.delete')}
                />
            </PageHeader>
        </div>
    )
}

export default GenderPage
